"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resourceDtTargetSchemas = void 0;
exports.getResourceDtTargetSchema = getResourceDtTargetSchema;
exports.parseResourceDtTargetResponse = parseResourceDtTargetResponse;
const zod_1 = require("zod");
const text = zod_1.z.string().trim().min(1);
const referentialReferenceSchema = zod_1.z
    .object({
    referentialKey: text,
    itemKey: text,
    itemId: zod_1.z.string().optional(),
    label: zod_1.z.string().optional(),
    categoryIds: zod_1.z.array(zod_1.z.string()).optional(),
})
    .strict();
const referentialValueSchema = zod_1.z.union([text, referentialReferenceSchema]);
const qualificationSchema = zod_1.z
    .object({
    year: zod_1.z.string().optional(),
    title: text,
    school: zod_1.z.string().optional(),
})
    .strict();
const skillGroupSchema = zod_1.z
    .object({
    category: zod_1.z.string().optional(),
    skills: zod_1.z.array(text),
})
    .strict();
const toolSchema = zod_1.z
    .object({
    name: text,
    level: zod_1.z.union([zod_1.z.string(), zod_1.z.number()]).optional(),
})
    .strict();
const projectSchema = zod_1.z
    .object({
    title: zod_1.z.string().optional(),
    context: zod_1.z.string().optional(),
    missions: zod_1.z.array(text),
    technologies: zod_1.z.array(text),
    skills: zod_1.z.array(text).optional(),
})
    .strict();
const experienceSchema = zod_1.z
    .object({
    type: zod_1.z.enum(['professional', 'personal', 'academic']).optional(),
    title: zod_1.z.string().optional(),
    company: zod_1.z.string().optional(),
    location: zod_1.z.string().optional(),
    startDate: zod_1.z.string().optional(),
    endDate: zod_1.z.string().nullable().optional(),
    context: zod_1.z.string().optional(),
    missions: zod_1.z.array(text),
    technologies: zod_1.z.array(text),
    skills: zod_1.z.array(text),
    projects: zod_1.z.array(projectSchema),
})
    .strict();
const languageSchema = zod_1.z
    .object({
    language: referentialValueSchema,
    level: referentialValueSchema.optional(),
})
    .strict();
exports.resourceDtTargetSchemas = {
    title: zod_1.z.string().trim().min(1),
    summary: zod_1.z.string().trim().min(1),
    presentation: zod_1.z.string().trim(),
    strengths: zod_1.z.array(text),
    softSkills: zod_1.z.array(text),
    skills: zod_1.z.array(zod_1.z.union([text, skillGroupSchema, referentialReferenceSchema])),
    domains: zod_1.z.array(zod_1.z.union([text, referentialReferenceSchema])),
    sectors: zod_1.z.array(zod_1.z.union([text, referentialReferenceSchema])),
    tools: zod_1.z.array(zod_1.z.union([text, toolSchema, referentialReferenceSchema])),
    experience: referentialValueSchema,
    experiences: zod_1.z.array(experienceSchema),
    education: zod_1.z.array(qualificationSchema),
    training: referentialValueSchema,
    diplomas: zod_1.z.array(qualificationSchema),
    certifications: zod_1.z.array(qualificationSchema),
    languages: zod_1.z.array(languageSchema),
    experienceYears: zod_1.z.number().finite().min(0).max(100).nullable(),
    miscellaneous: zod_1.z.string().trim(),
};
function getResourceDtTargetSchema(target) {
    return exports.resourceDtTargetSchemas[target];
}
function parseProviderJsonContent(content) {
    const providerContent = content && typeof content === 'object' && !Array.isArray(content) && 'choices' in content
        ? (content.choices?.[0]?.message?.content ??
            content)
        : content;
    return typeof providerContent === 'string' ? JSON.parse(providerContent) : providerContent;
}
function parseResourceDtTargetResponse(target, content) {
    const parsed = parseProviderJsonContent(content);
    const result = getResourceDtTargetSchema(target).safeParse(parsed);
    if (!result.success)
        throw result.error;
    return result.data;
}
